import React from "react";
import { Field, ErrorMessage } from "formik";
import Select from "react-select";

const EventTypeFields = ({
                           eventForm = {},
                           onChange,
                           favoriteStations = []
}) => {
  const eventType = eventForm.event_type || "";

  const stationOptions = favoriteStations.map((s) => ({
    value: s.id,
    label: s.name
  }));

  const selectedOptions =
      stationOptions.filter((opt) =>
          (eventForm.stations || []).includes(opt.value)
      );

  const sportOptions = [
    { value: "", label: "Select sport" },
    { value: "football", label: "football" },
    { value: "rugby", label: "rugby" },
    { value: "american football", label: "american football" },
    { value: "handball", label: "handball" },
    { value: "combat sports", label: "combat sports" },
    { value: "hockey", label: "hockey" },
    { value: "racing", label: "racing" },
    { value: "tennis", label: "tennis" },
    { value: "basketball", label: "basketball" },
    { value: "gaelic football", label: "gaelic football" },
    { value: "australian rules football", label: "australian rules football" },
    { value: "baseball", label: "baseball" },
    { value: "horse racing", label: "horse racing" },
    { value: "volleyball", label: "volleyball" },
    { value: "custom", label: "custom" },
    { value: "cricket", label: "cricket" },
    { value: "badminton", label: "badminton" },
    { value: "cycling", label: "cycling" },
    { value: "other", label: "other" },
  ];

  const nonSportOptions = [
    { value: "", label: "Select type" },
    { value: "Open mic", label: "Open mic" },
    { value: "Karaoke", label: "Karaoke" },
    { value: "Dj night", label: "Dj night" },
    { value: "Pub quiz", label: "Pub quiz" },
    { value: "Lady's night", label: "Lady's night" },
    { value: "Salsa night", label: "Salsa night" },
    { value: "Latino night", label: "Latino night" },
    { value: "Guys night", label: "Guys night" },
    { value: "Happy hour", label: "Happy hour" },
    { value: "Other", label: "Other" },
  ];

  let eventSubOptions = [];
  let eventSubTypeLabel = "Event sub type";

  if (eventType === "Sport") {
    eventSubOptions = sportOptions;
    eventSubTypeLabel = "Sport type";
  } else if (eventType === "non Sport") {
    eventSubOptions = nonSportOptions;
    eventSubTypeLabel = "Event sub type";
  }

  const handleEventTypeChange = (e) => {
    const newType = e.target.value;
    onChange("event_type", newType);
    onChange("event_sub_type", "");
    onChange("tv_stations", []);
  };

  const handleEventSubTypeChange = (e) => {
    onChange("event_sub_type", e.target.value);
  };

  const handleStationsChange = (selected) => {
    const values = selected ? selected.map(o => o.value) : [];
    onChange("stations", values);
  };

  return (
      <div className="row mb-3">
        {/* Column for "Event type" */}
        <div className="col-6">
          <label htmlFor="event_type" className="mb-1">
            Event type
          </label>
          <Field
              as="select"
              name="event_type"
              id="event_type"
              className="form-control"
              value={eventType}
              onChange={handleEventTypeChange}
          >
            <option value="">Select event type</option>
            <option value="Sport">Sport</option>
            <option value="non Sport">Custom</option>
          </Field>
          <ErrorMessage
            name="event_type"
            component="div"
            className="text-danger"
          />
        </div>

        {/* Column for "Event sub type" — hide when type="other" */}
        {eventType !== "other" && (
          <div className="col-6">
            <label htmlFor="event_sub_type" className="mb-1">
              {eventSubTypeLabel}
            </label>
            <Field
              as="select"
              name="event_sub_type"
              id="event_sub_type"
              className="form-control"
              value={eventForm.event_sub_type || ""}
              onChange={handleEventSubTypeChange}
            >
              {eventType === "Sport"
                ? sportOptions.map(opt => (
                        <option key={opt.value} value={opt.value}>
                            {opt.label}
                          </option>
                      ))
                : eventSubOptions.map(opt => (
                    <option key={opt.value} value={opt.value}>
                        {opt.label}
                      </option>
              ))}
            </Field>
            <ErrorMessage
              name="event_sub_type"
              component="div"
              className="text-danger"
            />
          </div>
        )}
        {eventType === "Sport" && (
            <div className="col-12 mb-3 mt-3">
              <div className="">
                <label htmlFor="tv_stations" className="mb-1">TV Stations</label>
                <Select
                    inputId="stations"
                    name="stations"
                    options={stationOptions}
                    value={selectedOptions}
                    onChange={handleStationsChange}
                    isMulti
                    isSearchable
                    className="react-select-container"
                    classNamePrefix="react-select"
                    placeholder="Search & select TV stations…"
                />
              </div>
            </div>
        )}
      </div>
  );
};

export default EventTypeFields;
